module.exports = __webpack_public_path__ + "static/media/zh-ch.83724493.md";


//////////////////
// WEBPACK FOOTER
// ./src/article/zh-ch.md
// module id = 1128
// module chunks = 0